// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23SUp","label":"styles_label__A91JT"};